import CardCollapse from './CardCollapse';

export default CardCollapse;
